export default {
      id: "icon--acco-gift-vouch-usage",
      viewBox: "0 0 32 25.3",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--acco-gift-vouch-usage",
      toString: function () {
        return this.url;
      }
    }